import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ResizeProvider {
	public data$ = new Subject<void>();
}
